import {capturePointer} from './pointerCapture.js';

export function wireTouchKey(button, {enabled, press, release}) {
    const pointers = new Set();
    button.style.touchAction = 'none';
    button.addEventListener('pointerdown', event => {
        if (event.button !== 0 || !enabled()) return;
        event.preventDefault(); event.stopPropagation();
        pointers.add(event.pointerId);
        capturePointer(button, event.pointerId);
        press(button);
    });
    for (const type of ['pointerup', 'pointercancel', 'lostpointercapture']) button.addEventListener(type, event => {
        if (!pointers.delete(event.pointerId)) return;
        event.preventDefault(); event.stopPropagation();
        if (!pointers.size) release(button);
        if (button.hasPointerCapture(event.pointerId)) button.releasePointerCapture(event.pointerId);
    });
    for (const type of ['touchstart', 'touchmove', 'touchend', 'touchcancel', 'contextmenu']) {
        button.addEventListener(type, event => { event.preventDefault(); event.stopPropagation(); }, {passive: false});
    }
    return () => {
        const ids = [...pointers]; pointers.clear(); release(button);
        for (const id of ids) if (button.hasPointerCapture(id)) button.releasePointerCapture(id);
    };
}
